import type { TeamsType } from "@/api_types/school";
import FetchService from "@/services/fetch.service";
import { asyncComputed } from "@/utils/asyncComputed";
import { sort } from "@/utils/sort";
import { defineStore } from "pinia";

export const useTeams = defineStore("directory/teams", {
  state: () => {
    return {
      teams: asyncComputed(
        async (controller) => {
          const res = (await FetchService.fetchData(
            "/teams",
            "get",
            undefined,
            undefined,
            controller
          )) as TeamsType;

          return sort(res || [], (i) => i.team_name);
        },
        [],
        undefined,
        false,
        []
      )
    };
  },
  actions: {
    async getTeam(uid: string) {
          const res = await FetchService.fetchData(`/teams/${uid}`, "get");
          return res;
        },
    async attach(team_uid: string, relationship: string, uid: string) {
      const res = await FetchService.fetchData(`/teams/${team_uid}/attach`, "put", {
        [relationship]: uid
      });
      return res;
    },
    async detach(team_uid: string, relationship: string, uids: string | string[]) {
      const payload = Array.isArray(uids) ? { [relationship]: uids } : { [relationship]: [uids] };
      const res = await FetchService.fetchData(`/teams/${team_uid}/detach`, "put", payload);
      return res;
    },
    async linkParenTeam(parent_uid, children_uid, team_uid) {
      const res = await FetchService.fetchData(`/teams/${team_uid}/attach`, "put", {
        parent_uid,
        children_uid
      });
      return res;
    },
    async linkTeacherTeam(teacher_uid, team_uid) {
      const res = await FetchService.fetchData(`/teams/${team_uid}/attach`, "put", { teacher_uid });
      return res;
    },
    async deleteParentTeamRelation(parent_uid, children_uid, team_uid) {
      const res = await FetchService.fetchData(`/teams/${team_uid}/detach`, "put", {
        parent_uid,
        children_uid
      });
      return res;
    },
    async updateTeamMembers(uid, newDescription) {
      const team = this.teams.data.find((t) => t.uid === uid); // Find the team by uid
      if (team) {
        console.log("Updating uid:"+uid+" with description: "+newDescription);
        team.teacher_description = newDescription; // Update the teacher_description field
      }else{
        console.log("Couldn't find team uid:"+uid);
      }
    },
    async deleteTeacherTeamRelation(teacher_uid, team_uid) {
      const res = await FetchService.fetchData(`/teams/${team_uid}/detach`, "put", { teacher_uid });
      return res;
    },
    async updateTeam(team_uid, teamData: Partial<TeamsType[number]>) {
      const res = await FetchService.fetchData(`/teams/${team_uid}`, "put", teamData);

      if (res?.team_name) {
        this.teams.data.forEach((t) => {
          if (t.uid === team_uid) Object.assign(t, res);
        });
        return true;
      }
      return false;
    },
    async createTeam(teamData: Partial<TeamsType[number]>) {
      const res = await FetchService.fetchData(`/teams`, "post", teamData);
      if (res?.uid) {
        res.deleted = false;
        this.teams.data = sort([...this.teams.data, res], (i) => i.team_name);
        return res.team_name as string;
      }
      return false;
    }
  }
});

export default useTeams;
